import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface DocumentDelete {
  id?: string;
  name: string;
  url?: string;
  docTypeId: string | undefined;
  referenceId?: string | undefined;
}

interface DocumentDeleteState {
  documentsDelete: DocumentDelete[];
  setDocumentsDelete: (newDocuments: DocumentDelete[] | undefined) => void;
}

export const useDocumentDeleteStore = create<DocumentDeleteState>()(
  devtools(
    (set) => ({
      documentsDelete: [],
      setDocumentsDelete: (newDocuments) =>
        set(() => ({
          documentsDelete: newDocuments ? [...newDocuments] : [],
        })),
    }),
    { name: "documentsDeleteedStore" }
  )
);
